import script from "./resetPasswordConfirm.vue?vue&type=script&setup=true&lang=ts"
export * from "./resetPasswordConfirm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__